import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const financialServices = [
    { name: 'Bookkeeping & Accounting', path: '/bookkeeping-accounting' },
    { name: 'Tax Preparation & Filing', path: '/tax-preparation' },
    { name: 'Payroll Management', path: '/payroll-management' },
    { name: 'Equity Management & Advisory', path: '/equity-management' },
    { name: 'Fund Administration', path: '/fund-administration' }
  ];

  const solutions = [
    { name: 'Software Development', path: '/solutions/software-development' },
    { name: 'AI & Machine Learning', path: '/solutions/ai-machine-learning' },
    { name: 'Cloud Solutions', path: '/solutions/cloud-solutions' },
    { name: 'DevOps & SRE', path: '/solutions/devops-sre' },
    { name: 'Data Analytics', path: '/solutions/data-analytics' }
  ];

  const toggleMobileDropdown = (dropdown) => {
    setMobileDropdown(mobileDropdown === dropdown ? null : dropdown);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <motion.nav 
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={handleLinkClick}>
          <span className="gradient-text">RKube Inc</span>
        </Link>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={handleLinkClick}>
            Home
          </Link>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setActiveDropdown('financial')}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            <span className="nav-link dropdown-trigger">
              Financial Services <FiChevronDown />
            </span>
            <div className={`dropdown-menu ${activeDropdown === 'financial' ? 'active' : ''}`}>
              {financialServices.map((item) => (
                <Link key={item.name} to={item.path} className="dropdown-item" onClick={handleLinkClick}>
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          <div 
            className="nav-dropdown"
            onMouseEnter={() => setActiveDropdown('solutions')}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            <span className="nav-link dropdown-trigger">
              Solutions <FiChevronDown />
            </span>
            <div className={`dropdown-menu ${activeDropdown === 'solutions' ? 'active' : ''}`}>
              {solutions.map((item) => (
                <Link key={item.name} to={item.path} className="dropdown-item" onClick={handleLinkClick}>
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          <Link to="/staffing" className="nav-link" onClick={handleLinkClick}>
            Staffing
          </Link>
          <Link to="/about" className="nav-link" onClick={handleLinkClick}>
            About Us
          </Link>
          <Link to="/careers" className="nav-link" onClick={handleLinkClick}>
            Careers
          </Link>
          <Link to="/contact" className="nav-link" onClick={handleLinkClick}>
            Contact
          </Link>
        </div>

        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX /> : <FiMenu />}
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
